import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React, { memo } from 'react';

import { white } from '../../../styles/mui/colors';
import useScreenSize from '../../../util/hooks/useScreenSize';
import { isCordova } from '../../../util/mobile/deviceDetection';
import { withBaseComponent } from '../hoc/withBaseComponent';

export const FULL_WIDTH_STYLE = false;

export const BLOCK_WIDTH_STYLE = 'xl';

/**
 * Full-height section style. The app has no TopBar, so there is nothing to subtract at lg.
 * @param {boolean} inApp
 */
export const getFullHeightStyle = (inApp) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: {
    md: '100vh',
    lg: inApp ? '100vh' : 'calc(100vh - var(--topbarHeightDesktop)) ',
  },
});

export const AUTO_HEIGHT_STYLE = {
  height: 'auto',
};

const prepareWidth = (width) => {
  return width === 'full' ? FULL_WIDTH_STYLE : width === 'block' ? BLOCK_WIDTH_STYLE : {};
};

const prepareXPadding = (width) => {
  return width === 'full' ? { px: '0px !important' } : width === 'block' ? {} : {};
};

const prepareHeight = (height, inApp) => {
  return height === 'full' ? getFullHeightStyle(inApp) : height === 'auto' ? AUTO_HEIGHT_STYLE : {};
};

const StoryblokGridSectionComponent = ({ blok, baseStyles, annualPassIsValid }) => {
  const { isMobile, isTablet } = useScreenSize();

  const {
    hideInApp = false,
    general = {
      items: [],
      width: 'block',
      height: 'auto',
      spacing: '4',
      background: white.default,
    },
    extra = { id: '' },
  } = blok;
  const { items, width, height, spacing, background } = general;
  const { id } = extra;

  if (isCordova() && hideInApp) {
    return null;
  }



  return (
    <Box
      component="section"
      sx={{
        padding: {
          xs: '40px 0',
          md: '60px 0 40px',
          lg: '96px 0 45px',
        },
        backgroundColor: background,
        ...prepareHeight(height, isCordova()),
        ...baseStyles,
      }}
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      <Container maxWidth={prepareWidth(width)} sx={ !isMobile && !isTablet ? prepareXPadding(width) : {} }>
        <Grid container id={id} p={0} spacing={parseInt(spacing)}>
          {items.map((nestedBlok, index) => (
            <StoryblokComponent
              annualPassIsValid={annualPassIsValid}
              blok={nestedBlok}
              index={index}
              key={nestedBlok._uid}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

StoryblokGridSectionComponent.displayName = 'StoryblokGridSection';
const StoryblokGridSection = memo(StoryblokGridSectionComponent);
// Full-width <section> — must not be shrunk by an alignment wrapper.
StoryblokGridSection.handlesAlignItems = true;

export default withBaseComponent(StoryblokGridSection);
